import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class NacimientoService {
    constructor(private http: HttpClient) { }

    traePostulantes(rut: any) {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }


    buscarHijo(rut: any) {
        return this.http.get(`${environment.urlApiSubsidio}/nacimiento/registroCivil/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }

    ingresarNacimiento(nacimiento: any, fechaNacimiento: any, fechaAdopcion: any, idAfiliado: any,idEjecutivo:any) {

        console.log(nacimiento.archivo)
   
        return this.http.post(`${environment.urlApiSubsidio}/solicitud/nacimiento`,
            {
                idUsuario: idAfiliado,
                idCarga: 0,
                idProducto: 8,
                archivoAdjunto: nacimiento.archivo,
                idEjecutivoAsignado:idEjecutivo,
                nacimiento: {
                    montoSolicitado: nacimiento.rutAfiliado,
                    tipoNacimiento: nacimiento.tipoNacimiento,
                    fechaNacimiento: fechaNacimiento,
                    fechaAdopcion: fechaAdopcion,
                    nombreCompleto: nacimiento.nombres,
                    rutHijo: nacimiento.rutHijo
                }

            },
            { headers: this.armaCabecera() }).toPromise();
    }
  
    editarNacimiento(data: any, fechaNacimiento: any, fechaAdopcion: any,idUsuario: any ,idUsuarioSesion: any) {
       
        return this.http.put(`${environment.urlApiSubsidio}/solicitud/nacimiento`,
            {
                idUsuario: idUsuario,
                id: data.idPostulacion,
                idProducto: 8,
                nacimiento: {
                    montoSolicitado: data.rutAfiliado,
                    tipoNacimiento: data.tipoNacimiento,
                    fechaNacimiento: fechaNacimiento,
                    fechaAdopcion: fechaAdopcion,
                    nombreCompleto: data.nombreCompletoHijo,
                    rutHijo: data.rutHijo
                }
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    traeTipoNacimiento() {

        return this.http.get(`${environment.urlApiSubsidio}/getTipoNacimiento`,
            { headers: this.armaCabecera() }).toPromise();
    }

    armaCabecera() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}